import * as React from 'react';

import { makeStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import CheckIcon from '@material-ui/icons/Check';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';

const useStyles = makeStyles((theme) => ({
  pago: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#4caf50',
  },
  pendente: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#f44336',
  },
}));

// verde: pago; vermelho: pagamento pendente
const PagoField = ({ record }) => {
  const classes = useStyles();
  const pago = !!(record && record.pago);

  return (
    <Tooltip title={pago ? 'Pago' : 'Pagamento pendente'}>
      <Avatar className={pago ? classes.pago : classes.pendente}>
        {pago ? (
          <CheckIcon style={{ fontSize: 15 }} />
        ) : (
          <PriorityHighIcon style={{ fontSize: 15 }} />
        )}
      </Avatar>
    </Tooltip>
  );
};

export default PagoField;
